import Fact from './Fact';
import './Fact.scss';

export default Fact;
